import { PRIVATE_ADMIN } from 'Shared/Routing/Application/Constants/PathsConstant';

export const PRIVATE_ADMIN_EXTRA_INSTALLATION = PRIVATE_ADMIN + '/extra-installation';
export const PRIVATE_ADMIN_EXTRA_INSTALLATION_FORM = PRIVATE_ADMIN_EXTRA_INSTALLATION + '/form';
